//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import experimentMixin from '@motionelements/core/src/components/mixins/experiment.mixin.js';
import { listCurations } from '@/api/channels.js';

export default {
  name: 'SubscribeCurations',
  mixins: [experimentMixin],
  data() {
    return {
      curations: [],
      isCurationsLoading: false,
    };
  },
  computed: {
    curationLink() {
      return (curation) => _.get(curation, 'html.url');
    },
    curationImage() {
      return (curation) => _.get(curation, 'backgroundImage.url');
    },
  },
  async fetch() {
    return this.listCurations();
  },
  methods: {
    async listCurations() {
      this.isCurationsLoading = true;
      return listCurations('subscribe', {
        page: 1,
        per_page: 3,
        'fields[page]': 'heading,background_image,html',
      })
        .then((response) => {
          // console.log(response.data);
          const curations = _.get(response, 'data.data');
          this.curations = curations ? curations : [];
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.isCurationsLoading = false;
        });
    },
  },
};
